import { useLang } from "@/context/LanguageContext";
import { contacts } from "@/data/content";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight, DownloadSimple, ArrowRight } from "@phosphor-icons/react";
import { media } from "@/data/content";

const postImgs = [media.gallery.living, media.gallery.tessili, media.gallery.bagno];

export const NewsBlog = () => {
  const { t } = useLang();
  return (
    <section id="news" data-testid="news" className="relative bg-[#F3EFEA] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal>
              <p className="text-sm tracking-luxe uppercase text-[#A39B8E] mb-6">{t.news.kicker}</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                {t.news.title}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {t.news.posts.map((p, i) => (
            <Reveal key={i} delay={i * 0.08} className="group cursor-pointer">
              <div className="overflow-hidden aspect-[4/3] mb-5">
                <img src={postImgs[i]} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
              </div>
              <span className="text-xs tracking-luxe uppercase text-[#8B7355]">{p.tag}</span>
              <h3 className="mt-2 font-display text-2xl font-light group-hover:text-[#8B7355] transition-colors flex items-start gap-2">
                {p.title}
                <ArrowUpRight size={20} className="mt-1 opacity-0 group-hover:opacity-100 transition-opacity" />
              </h3>
              <p className="mt-2 text-sm text-[#1A1A1A]/60 leading-relaxed">{p.text}</p>
            </Reveal>
          ))}
        </div>

        {/* Download area */}
        <Reveal className="mt-16 md:mt-20">
          <div className="bg-[#1A1A1A] text-[#FAFAF7] p-10 md:p-16 flex flex-col md:flex-row md:items-center justify-between gap-8">
            <div className="max-w-xl">
              <p className="text-sm tracking-luxe uppercase text-[#8B7355] mb-4">{t.news.download.title}</p>
              <h3 className="font-display font-light text-3xl md:text-4xl leading-tight">{t.news.download.text}</h3>
            </div>
            <a
              data-testid="download-brochure"
              href={contacts.brochure}
              download
              className="group inline-flex items-center gap-3 bg-[#FAFAF7] text-[#1A1A1A] px-8 py-4 text-sm shrink-0 hover:bg-[#8B7355] hover:text-white transition-colors duration-300"
            >
              <DownloadSimple size={18} />
              {t.news.download.cta}
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
